define('collections/leads',['require','collections/base','models/lead'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/lead");

    return BaseCollection.extend({
        model: Model,
        url: 'leads.json'
    });
});

